import React from 'react';
import { Box, Typography } from '@mui/material';

const Logo = ({ variant = 'default', size = 'medium' }) => {
  const sizeMap = {
    small: { width: 30, height: 30, fontSize: '14px' },
    medium: { width: 40, height: 40, fontSize: '18px' },
    large: { width: 60, height: 60, fontSize: '24px' }
  };

  const currentSize = sizeMap[size];

  if (variant === 'text') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 700, 
            color: 'primary.main',
            fontSize: currentSize.fontSize
          }}
        >
          TVS
        </Typography>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 400, 
            color: 'text.secondary',
            fontSize: currentSize.fontSize,
            ml: 0.5
          }}
        >
          Latin America
        </Typography>
      </Box>
    );
  }

  return (
    <img 
    src="/logo.png" 
    alt="TVS Latin America" 
    style={{ 
        width: currentSize.width, 
        height: currentSize.height,
        objectFit: 'contain'
    }} 
    />
  );
};

export default Logo;

